import NoticeMap from './NoticeMap'
export default NoticeMap;


// WEBPACK FOOTER //
// ./src/components/App/NoticesLoader/NoticeDetail/NoticeMap/index.js